// extracted by mini-css-extract-plugin
export var navbar = "nav-module--navbar--e1e8b";
export var navlink = "nav-module--navlink--60bc1";
export var notselected = "nav-module--notselected--32cd8";
export var selected = "nav-module--selected--fff71";
export var toggle = "nav-module--toggle--75eb5";